<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
        <ul>
          <li>
            <a href="#">
              Tactical Bitcoin
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright pull-right">
        &copy; 2022 Tactical Bitcoin LLC
       
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
